import Model, { attr } from '@ember-data/model';

export default class EventModel extends Model {
  @attr('string') contactId?: string;
  @attr('string') lineItemId?: string;
  @attr('string') pledgeId?: string;
  @attr('date-only') declare occurredAt: Date;
  @attr('number') declare eventTypeId: number;
  @attr() custom: any;
  @attr('boolean') declare read: boolean;
}
